import { DateUtil } from '@src/packages/utils/dates';
import { SWITCH_TIME_ZONE } from 'constants/ActionTypes';

import { storage } from 'packages/utils';

export function switchTimeZone(tz) {
  // Do nothing if you get an empty string
  if (!tz) {
    return () => null;
  }
  storage.set('timeZone', tz);
  DateUtil.setDefaultTimeZone(tz);
  return dispatch => {
    dispatch({
      type: SWITCH_TIME_ZONE,
      payload: tz,
    });
  };
}
